import { fetcher } from '@commenda/utils';

interface RemoveCAFirmInputProp {
  corporationId: number;
  caFirmId: string;
}

export default async function unassignCAFirmFromCorporation({
  data,
  token,
}: {
  data: RemoveCAFirmInputProp;
  token: string;
}): Promise<boolean> {
  try {
    const res = await fetcher(
      `caFirm/${data.caFirmId}/removeCAFirmByCorporation/${data.corporationId}`,
      {
        method: 'DELETE',
        body: {},
      },
      token
    );
    return res.ok;
  } catch (err) {
    console.error(err);
    return false;
  }
}
